import * as react from "react";

export function useInterval(callback, delayMs) {
    const savedCallback = react.useRef(() => {
    });
    react.useEffect(() => {
        savedCallback.current = callback;
    });
    react.useEffect(() => {
        const disp = (() => {
        const id = setInterval(() => {
            savedCallback.current();
        }, delayMs) | 0;
        return {
            Dispose() {
                clearInterval(id);
            },
        };
    })();
        return () => disp.Dispose();
    }, [delayMs]);
}

